import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async () => {
    // Check if user is authenticated using mock auth
    const mockUserJson = sessionStorage.getItem('mockUser');
    const mockUser = mockUserJson ? JSON.parse(mockUserJson) : null;

    if (!mockUser) {
      throw redirect({
        to: '/login',
      });
    }
  },
  component: () => <Outlet />,
});
